module.exports = __webpack_public_path__ + "assets/img/e6287ff1adbde52051aaf9ded07d02c2.png";